import AdminConsole from '@/components/AdminConsole';
const AccessPage = () => {
  return (
    <>
      <div style={{ position: 'relative', height: 'auto' }}>
        <AdminConsole />
      </div>
    </>
  );
};

export default AccessPage;
